﻿import { getTranslations } from "../translations";

export class numberSelectEvent
{
    value: number;
    oldValue: number;
    originalEvent: Event;
}

export class numberSelect
{
    private realInput: HTMLInputElement;
    private wrapper: HTMLElement;
    private select: HTMLSelectElement | null = null;
    private upperLimit: number;
    private value: number;
    private orgValue: number;
    private onChange: (event: Event) => void | null;

    constructor(input: HTMLInputElement, onChange?: (event: Event) => void | null)
    {
        if (input.closest(".u-number-select"))
            return;

        this.onChange = (e) =>
        {
            if (onChange)
            {
                onChange(e);
            }
        };

        $(input).wrap("<div />");
        this.realInput = input;

        this.wrapper = input.parentElement ?? input;
        this.wrapper.className = "u-number-select";

        this.upperLimit = this.getUpperLimit();
        this.value = this.getValue();
        this.orgValue = this.value;

        // Create dropdown
        this.select = this.createSelect();

        // hide input on rendering    
        this.realInput.classList.add("hidden");

        this.attachEvents();

        // Don't show input when value above 9
        if (this.value > 9)
            this.showInput();
    }

    // --- PUBLIC ---
    public getValue(): number | null
    {
        const val = Number(this.realInput.value);
        return isNaN(val) ? null : val;
    }

    // --- PRIVATE ---
    private getUpperLimit(): number
    {
        const max = this.realInput.max ? Number(this.realInput.max) : Infinity;
        return Math.min(max, 9);
    }

    private showInput(): void
    {
        this.realInput.classList.remove("hidden");
        this.select.parentElement.classList.add("hidden");
    }

    private showSelect(): void
    {
        this.realInput.classList.add("hidden");
        this.select.parentElement.classList.remove("hidden");
    }

    private createSelect(): HTMLSelectElement
    {
        const selectWrapper = document.createElement("div");
        selectWrapper.className = "u-select-holder";

        const select = document.createElement("select");
        select.className = "number-select";

        for (let i = 1; i <= this.upperLimit; i++)
        {
            const opt = document.createElement("option");
            opt.value = String(i);
            opt.textContent = String(i);
            if (i === this.value)
                opt.selected = true;
            select.appendChild(opt);
        }

        const other = document.createElement("option");
        other.value = "other";
        other.textContent = getTranslations().txtMore;
        select.appendChild(other);

        selectWrapper.appendChild(select);
        this.wrapper.insertBefore(selectWrapper, this.realInput);

        return select;
    }

    private attachEvents(): void
    {
        if (!this.select) return;

        this.select.addEventListener("change", (e) => this.onSelectChange(e));
        this.realInput.addEventListener("blur", (e) => this.onInputBlur(e));
    }

    private onSelectChange(e): void
    {
        const oldValue = this.value;
        if (!this.select) return;

        if (this.select.value === "other")
        {
            // Show input
            this.showInput();
            this.realInput.value = "";
            this.realInput.focus();
        } else
        {
            // Hide input and sync values
            this.realInput.value = this.select.value;
            this.value = parseInt(this.realInput.value);
            this.triggerEvent(e, oldValue, this.value);
            this.showSelect();
        }
    }

    private onInputBlur(e): void
    {
        if (!this.select) return;

        const val = Number(this.realInput.value);
        if (val > 0)
        {
            const oldValue = this.value;

            if (!val || val > this.upperLimit)
            {
                // when choosing other, show input
                this.select.value = "other";
                this.showInput();
            } else
            {
                // within dropdown range, show select and sync values
                this.select.value = String(val);
                this.showSelect();
            }
            this.value = parseInt(this.realInput.value);
            this.triggerEvent(e, oldValue, val);
        }
    }

    private triggerEvent(event: Event, oldValue: number, value: number)
    {
        const customEvent = new CustomEvent<numberSelectEvent>("change", { detail: { value: value, oldValue: oldValue, originalEvent: event } });
        this.onChange(customEvent);
    }
}
